import React, { Component } from "react";
import * as Constanti from '../../Utils/constants.js';
import '../../style/cards.css';
import '../../style/generic.css';
import moment from "moment";
import ellipse from '../../images/Ellipse6.png';


class CardHomeMobile extends Component{
  constructor(props){
    super(props);
     this.state = {
            imageUrl: this.props.thumbnail
        };
        
}
handleError = () => {
        this.setState({
            imageUrl: Constanti.url_img_new + this.props.thumbnail
        });
    }


  render(){
    return (
      <>
    
       
      <div className={"card-small "+(this.props.isCat ? "card-small-category":"")} >
     <div className="img-card-small" style={{
                backgroundImage: `linear-gradient(
        180deg,
        rgba(13, 22, 35, 0) 55.92%,
        rgba(13, 22, 35, 0.822262) 86.73%,
        #0D1623 100.04%
      ), url(${this.state.imageUrl})`
            }}>
                <img 
                    src={this.state.imageUrl} 
                    onError={this.handleError} 
                    style={{ display: 'none' }} 
                    alt="Thumbnail" 
                />
            </div>
          
      <div className="details-card-small">
      <div className="card-info-wrapper cardInfoMobile">
      {this.props.isDiretta &&
       <div className="liveBox flex horizontal justify-center align-center padding-bottom-32">
          <img src={ellipse} width={6} height={6} alt="" className="imgLive"/><span>Live</span>
          </div>
      }
      <h4 className="h4">{this.props.title != null && this.props.title.length > 53 ? this.props.title.substring(0,52)+"..." : this.props.title}</h4>
    </div>
    </div>
	</div>
   </>)
}
}
export default CardHomeMobile; 





